import { css } from "emotion";
import React, { Component } from "react";
import { Link } from "react-router-dom";
import Button from "./Button";
import Container from "./Container";

export default class Nav extends Component {
  render() {
    return (
      <nav
        className={css`
          z-index: 9001;
          position: relative;
          height: 70px;
          display: flex;
          align-items: center;
        `}
      >
        <Container
          className={css`
            display: flex;
            align-items: center;
            justify-content: space-between;
          `}
        >
          <Link to="/">
            <img
              src={require("../assets/images/logo.png")}
              alt="The Unstuck Group"
              role="logo"
              className={css`
                height: 40px;
              `}
            />
          </Link>
          <Button to="/signin" kind="outline">
            Sign In
          </Button>
        </Container>
      </nav>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Nav.js